import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../../common/store/generic.selectors';
import { KnownIpAddressModel, knownIpAddressFeatureKey } from './types';
import { IKnownIpAddressState } from './known-ip-address.reducer';

const knownIpAddressFeatureState = createFeatureSelector<IKnownIpAddressState>(
  knownIpAddressFeatureKey,
);

export const knownIpAddressSelectors = {
  getById: createApiCallSelectors<KnownIpAddressModel, IKnownIpAddressState>(
    knownIpAddressFeatureState,
    'getById',
  ),
  update: createApiCallSelectors<KnownIpAddressModel, IKnownIpAddressState>(
    knownIpAddressFeatureState,
    'update',
  ),
};
